"use client";
import { Stack } from "@chakra-ui/react";
import DataCenterMap from "@/components/dataCenterMap";
import { Button } from "@/elements";
import { scrollToElement } from "@/utils/scrollToElement";

const MapComponent = () => {
  return (
    <Stack w={"100%"}>
      <DataCenterMap asLink={false} />
      <Button
        variant={"ideal"}
        onClick={() => scrollToElement("dataCenters", 140)}
        alignSelf={"center"}
      >
        Explore our Data Centers
      </Button>
    </Stack>
  );
};

export default MapComponent;
